var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('b-overlay',{attrs:{"show":_vm.loading,"no-wrap":""}}),_c('b-card',[_c('div',{ref:"map",attrs:{"id":"zones-map"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }